import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import toast from "react-hot-toast";

import { LoadAccountDetails } from "../../../redux/v2/user/actions";

import Logout from "../../../common/Logout";
import PaddedContentArea from "../../../common/PaddedContentArea";
import Details from "./Details";

function PersonalInfo(props) {
    const navigate = useNavigate();

    return (
        <>
            <Logout showLogo={true} />
            <div id="getting-started-v2" className="flex-c content-area">
                <div id="getting-started-v2-wrapper">
                    <PaddedContentArea>
                        <Details next={async (toastId) => {
                            const res = await props?.LoadAccountDetails();
                            if (res) {
                                toast.dismiss(toastId);
                                // navigate("/getting-started");
                            } else {
                                toast.error("Encountered issue while setting up account!", {
                                    id: toastId,
                                });
                            }
                        }} />
                    </PaddedContentArea>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
    LoadAccountDetails,
})(PersonalInfo);
